export interface Comment {
  id: string;
  videoHash: string;
  userId: string;
  username: string;
  text: string;
  createdAt: number;
}

const COMMENTS_KEY = 'authenticulture_comments';

type CommentListener = () => void;
let commentListeners: CommentListener[] = [];

export function addCommentListener(fn: CommentListener): () => void {
  commentListeners.push(fn);
  return () => { commentListeners = commentListeners.filter(l => l !== fn); };
}

function notifyCommentListeners(): void {
  commentListeners.forEach(fn => fn());
}

export function saveIncomingComment(comment: Comment): void {
  const comments = getAllComments();
  if (comments.some(c => c.id === comment.id)) return;
  comments.push(comment);
  localStorage.setItem(COMMENTS_KEY, JSON.stringify(comments));
  notifyCommentListeners();
}

export function getCommentsForVideo(videoHash: string): Comment[] {
  return getAllComments()
    .filter(c => c.videoHash === videoHash)
    .sort((a, b) => b.createdAt - a.createdAt);
}

export function getAllComments(): Comment[] {
  const stored = localStorage.getItem(COMMENTS_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function deleteComment(commentId: string, userId: string): boolean {
  const comments = getAllComments();
  const index = comments.findIndex(c => c.id === commentId && c.userId === userId);
  if (index === -1) return false;
  comments.splice(index, 1);
  localStorage.setItem(COMMENTS_KEY, JSON.stringify(comments));
  notifyCommentListeners();
  return true;
}
